import { shallowEqual } from 'react-redux'
import { useAppSelector } from 'src/store/hooks'

export const useAthlete = () =>
    useAppSelector((state) => state.athleteProfile, shallowEqual)
